"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledIcon = exports.StyledTypography = exports.IndicatorWrapper = exports.classes = void 0;
const styles_1 = require("@mui/material/styles");
const Icon_1 = __importDefault(require("../icon/Icon"));
const typography_1 = __importDefault(require("../typography"));
const PREFIX = "GoodBetterBestIndicator";
exports.classes = {
    good: `${PREFIX}-good`,
    better: `${PREFIX}-better`,
    best: `${PREFIX}-best`,
    notStarted: `${PREFIX}-notStarted`,
    failed: `${PREFIX}-failed`,
    inProgress: `${PREFIX}-inProgress`,
    enrolled: `${PREFIX}-enrolled`,
    completed: `${PREFIX}-completed`,
    allBooked: `${PREFIX}-allBooked`,
    expired: `${PREFIX}-expired`,
    small: `${PREFIX}-small`,
    medium: `${PREFIX}-medium`,
    rounded: `${PREFIX}-rounded`
};
exports.IndicatorWrapper = (0, styles_1.styled)("div")(({ theme }) => ({
    width: "fit-content",
    display: "flex",
    alignItems: "center",
    borderTopRightRadius: "3px",
    borderBottomRightRadius: "3px",
    boxShadow: "0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.12), 0px 1px 3px 0px rgba(0,0,0,0.20)",
    [`&.${exports.classes.good}`]: {
        backgroundColor: theme.colours.teal400,
        color: theme.colours.white
    },
    [`&.${exports.classes.better}`]: {
        backgroundColor: theme.colours.purple400,
        color: theme.colours.white
    },
    [`&.${exports.classes.best}`]: {
        backgroundColor: theme.colours.orange400,
        color: theme.colours.white
    },
    [`&.${exports.classes.notStarted}`]: {
        backgroundColor: theme.colours.cyan100,
        color: theme.colours.charcoal
    },
    [`&.${exports.classes.failed}`]: {
        backgroundColor: theme.colours.orange100,
        color: theme.colours.charcoal
    },
    [`&.${exports.classes.inProgress}`]: {
        backgroundColor: theme.colours.yellow100,
        color: theme.colours.charcoal
    },
    [`&.${exports.classes.enrolled}`]: {
        backgroundColor: theme.colours.aqua100,
        color: theme.colours.brandGreenInter
    },
    [`&.${exports.classes.completed}, &.${exports.classes.allBooked}, &.${exports.classes.expired}`]: {
        backgroundColor: theme.colours.storm,
        color: theme.colours.charcoal
    },
    [`&.${exports.classes.small}`]: {
        padding: "3px 6px"
    },
    [`&.${exports.classes.medium}`]: {
        padding: "6px 12px"
    },
    [`&.${exports.classes.rounded}`]: {
        borderTopLeftRadius: "3px",
        borderBottomLeftRadius: "3px"
    }
}));
exports.StyledTypography = (0, styles_1.styled)(typography_1.default)({
    fontSize: "14px",
    textTransform: "uppercase",
    lineHeight: "16px",
    fontFamily: "Effra Bold"
});
exports.StyledIcon = (0, styles_1.styled)(Icon_1.default)({
    width: "16px",
    height: "16px",
    marginRight: "6px"
});
//# sourceMappingURL=data:application/json;base64,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